export const salesDashboardAr = {
  salesDashboard: {
    title: 'لوحة المبيعات',
    subtitle: 'الكميات المسلمة والمقارنات وتتبع الأهداف',
    loading: 'جاري التحميل...',
    noData: 'لا توجد بيانات',
    lastUpdated: 'آخر تحديث',
    stats: {
      totalTons: 'إجمالي التسليم',
      deliveries: 'التسليمات',
      totalTrips: 'إجمالي الرحلات',
      change: 'تغيير الفترة',
      changeTons: 'التغيير (طن)',
      tons: 'طن',
      increase: 'زيادة',
      decrease: 'انخفاض',
      noChange: 'لا تغيير',
      daysWithData: 'أيام نشطة',
      activeDays: 'أيام نشطة',
      days: 'أيام',
      avgDaily: 'المعدل اليومي',
      tonsPerDay: 'طن/يوم',
      vsPreviousPeriod: 'مقارنة بالفترة السابقة',
      vsSamePeriodLastYear: 'مقارنة بنفس الفترة العام الماضي',
      current: 'الحالي',
      previous: 'السابق',
    },
    chart: {
      dailyTitle: 'الكميات المسلمة يومياً',
      comparisonTitle: 'المقارنة',
      deliveredTons: 'المسلّم (طن)',
    },
    comparison: {
      dod: 'يوم/يوم',
      wow: 'أسبوع/أسبوع',
      mom: 'شهر/شهر',
      dodFull: 'يوم مقارنة بيوم',
      wowFull: 'أسبوع مقارنة بأسبوع',
      momFull: 'شهر مقارنة بشهر',
    },
    breakdown: {
      label: 'تقسيم حسب',
      none: 'بدون تقسيم',
      title: 'التقسيم',
      factory: 'المصنع',
      customer: 'العميل',
      city: 'موقع التسليم',
      sku: 'المنتج',
      variant: 'المنتج',
      name: 'الاسم',
      currentTons: 'الحالي (طن)',
      currentOrders: 'الطلبات (الحالي)',
      previousTons: 'السابق (طن)',
      previousOrders: 'الطلبات (السابق)',
      changePct: 'نسبة التغيير',
    },
    dateRange: {
      today: 'اليوم',
      yesterday: 'أمس',
      thisWeek: 'هذا الأسبوع',
      lastWeek: 'الأسبوع الماضي',
      thisMonth: 'هذا الشهر',
      lastMonth: 'الشهر الماضي',
      thisQuarter: 'هذا الربع',
      thisYear: 'هذا العام',
      last30Days: 'آخر 30 يوم',
      custom: 'مخصص',
    },
    filters: {
      label: 'التصفية',
      searchFactory: 'ابحث عن المصانع...',
      searchCustomer: 'ابحث عن العملاء...',
      searchCity: 'ابحث عن المدن...',
      searchProduct: 'ابحث عن المنتجات...',
      clearAll: 'مسح جميع التصفيات',
      noResults: 'لا توجد نتائج.',
      loading: 'جاري التحميل...',
      clear: 'مسح',
    },
    export: {
      button: 'تصدير',
      downloading: 'جاري التصدير...',
      sheetDaily: 'المبيعات اليومية',
      sheetBreakdown: 'التقسيم',
      colDate: 'التاريخ',
      colTons: 'المسلّم (طن)',
      colDeliveries: 'التسليمات',
      colName: 'الاسم',
      colCurrentTons: 'الحالي (طن)',
      colCurrentOrders: 'الطلبات (الحالي)',
      colPreviousTons: 'السابق (طن)',
      colPreviousOrders: 'الطلبات (السابق)',
      colChangePct: 'نسبة التغيير %',
    },
    targets: {
      title: 'الأهداف الشهرية',
      subtitle: 'إدارة أهداف التسليم لكل مصنع',
      progressTitle: 'تقدم الأهداف',
      remaining: 'المتبقي',
      addTarget: 'إضافة هدف',
      editTarget: 'تعديل الهدف',
      month: 'الشهر',
      factory: 'المصنع',
      selectFactory: 'اختر المصنع',
      variant: 'المنتج',
      allVariants: 'جميع المنتجات (الإجمالي)',
      variantHint: 'اتركه "جميع المنتجات" لهدف إجمالي المصنع',
      targetQuantity: 'الكمية المستهدفة',
      notes: 'ملاحظات',
      empty: 'لا توجد أهداف',
      status: 'الحالة',
      current: 'الحالي',
      past: 'سابق',
      future: 'قادم',
      total: 'الإجمالي',
      deleteConfirmTitle: 'حذف الهدف',
      deleteConfirmDescription: 'هل أنت متأكد من حذف هذا الهدف؟ لا يمكن التراجع عن هذا الإجراء.',
      deleteConfirmAction: 'حذف',
      allMonths: 'جميع الأشهر',
      totalTargets: 'إجمالي الأهداف',
      totalQuantity: 'إجمالي الكمية',
      factoriesCovered: 'المصانع',
      avgPerFactory: 'المعدل لكل مصنع',
      manageTargets: 'إدارة الأهداف',
      noTargetsForMonth: 'لا توجد أهداف لهذا الشهر. حدد الأهداف لتتبع تقدم التسليم.',
      monthsWithTargets: '{{count}} أشهر مع أهداف',
      validation: {
        monthFormat: 'الصيغة: YYYY-MM',
        required: 'مطلوب',
        positive: 'يجب أن يكون رقماً موجباً',
      },
    },
    subCustomers: {
      admin: {
        title: 'لوحة العملاء الفرعيين',
        subtitle: 'الطلبات والأطنان المسلّمة حسب العميل الفرعي',
        entity: 'العميل الفرعي',
        code: 'رمز العميل الفرعي',
        active: 'العملاء الفرعيون النشطون',
        total: 'أطنان العملاء الفرعيين',
        topTitle: 'أعلى 20 عميلاً فرعياً',
        searchPlaceholder: 'ابحث عن عميل فرعي بالاسم أو الرمز…',
        noSubCustomer: 'بدون عميل فرعي',
        exportThis: 'تصدير هذا العميل الفرعي',
        exportDescription: 'جميع الطلبات المسلّمة التي لها عميل فرعي وتطابق فلاتر الصفحة والمصنع/العميل المحدد في الأعلى.',
      },
      customer: {
        title: 'لوحة العملاء',
        subtitle: 'الطلبات والأطنان المسلّمة حسب العميل',
        entity: 'العميل',
        code: 'رمز العميل',
        active: 'العملاء النشطون',
        total: 'أطنان العملاء',
        topTitle: 'أعلى 20 عميلاً',
        searchPlaceholder: 'ابحث عن عميل بالاسم أو الرمز…',
        noSubCustomer: 'بدون عميل',
        exportThis: 'تصدير هذا العميل',
        exportDescription: 'جميع الطلبات المسلّمة التي لها عميل وتطابق فلاتر الصفحة والمصنع المحدد في الأعلى.',
      },
      mainCustomer: 'العميل الرئيسي',
      plant: 'المصنع',
      city: 'المدينة',
      cementType: 'نوع الإسمنت',
      orders: 'الطلبات',
      tons: 'الأطنان',
      ordersUnit: 'طلب',
      share: 'الحصة',
      rank: '#',
      date: 'التاريخ',
      unknownCustomer: 'عميل غير معروف',
      unknown: 'غير معروف',
      other: 'أخرى',
      noData: 'لا توجد تسليمات تطابق هذه الفلاتر',
      lockedHint: 'محدد من الأعلى',
      rangeTooLong: 'اختر فترة لا تزيد عن {{days}} يوماً',
      view: { label: 'العرض', chart: 'رسم بياني', table: 'جدول' },
      kpi: {
        orders: 'الطلبات المسلّمة',
        avgTonsPerOrder: 'متوسط الأطنان لكل طلب',
      },
      charts: {
        trend: 'الأطنان والطلبات المسلّمة يومياً',
        byCementType: 'حسب نوع الإسمنت',
        byCity: 'حسب المدينة',
        byPlant: 'حسب المصنع',
      },
      filters: {
        button: 'الفلاتر',
        title: 'الفلاتر',
        dateRange: 'الفترة',
        clearAll: 'مسح الكل',
        done: 'تم',
      },
      search: { noResults: 'لا توجد نتائج', minChars: 'اكتب حرفين على الأقل', searching: 'جاري البحث…' },
      detail: {
        cities: 'المدن',
        plants: 'المصانع',
        cementTypes: 'أنواع الإسمنت',
      },
      export: {
        button: 'تصدير',
        title: 'تصدير الطلبات',
        dateLabel: 'الفترة',
        download: 'تنزيل',
        cancel: 'إلغاء',
        only: 'فقط',
        empty: 'لا توجد طلبات للتصدير في هذه الفترة',
        narrowRange: 'عدد الطلبات كبير جداً لملف واحد (الحد 50,000 طلب و366 يوماً كحد أقصى). قلّص الفترة.',
        failed: 'فشل التصدير',
        sheet: 'الطلبات',
        colOrderNumber: 'رقم الطلب',
        colDeliveryDay: 'يوم التسليم',
      },
      error: { title: 'تعذّر تحميل اللوحة', retry: 'إعادة المحاولة' },
    },
  },
}
